<template>
    <UtilitiesWebView url="/city-tours/river-cruise" />
</template>
